var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: { title: "Home Environment", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c("InfoField", {
          staticClass: "mb-4",
          attrs: {
            label: "Pets",
            value: _vm.data.home_env_pets,
            defaultText: "N/A",
          },
        }),
        _c("InfoField", {
          staticClass: "mb-4",
          attrs: {
            label: "Accessibility Issues",
            value: _vm.data.home_env_accessibility_issues,
            defaultText: "N/A",
          },
        }),
        _c("InfoField", {
          staticClass: "mb-4",
          attrs: {
            label: "Safety Concerns",
            value: _vm.data.home_env_safety,
            defaultText: "N/A",
          },
        }),
        _c("InfoField", {
          staticClass: "mb-4",
          attrs: {
            label: "General Notes",
            value: _vm.data.home_env_notes,
            defaultText: "N/A",
          },
        }),
        _c("InfoSection"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }